/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Request_Email_LabelInputs */

const en_reset_request_email_label = /** @type {(inputs: Reset_Request_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/** @type {(inputs: Reset_Request_Email_LabelInputs) => LocalizedString} */
const ar_reset_request_email_label = en_reset_request_email_label;

/** @type {(inputs: Reset_Request_Email_LabelInputs) => LocalizedString} */
const he_reset_request_email_label = en_reset_request_email_label;

/** @type {(inputs: Reset_Request_Email_LabelInputs) => LocalizedString} */
const ur_reset_request_email_label = en_reset_request_email_label;

/** @type {(inputs: Reset_Request_Email_LabelInputs) => LocalizedString} */
const es_reset_request_email_label = en_reset_request_email_label;

/** @type {(inputs: Reset_Request_Email_LabelInputs) => LocalizedString} */
const fr_reset_request_email_label = en_reset_request_email_label;

/** @type {(inputs: Reset_Request_Email_LabelInputs) => LocalizedString} */
const de_reset_request_email_label = en_reset_request_email_label;

/** @type {(inputs: Reset_Request_Email_LabelInputs) => LocalizedString} */
const pt_reset_request_email_label = en_reset_request_email_label;

/** @type {(inputs: Reset_Request_Email_LabelInputs) => LocalizedString} */
const hi_reset_request_email_label = en_reset_request_email_label;

/** @type {(inputs: Reset_Request_Email_LabelInputs) => LocalizedString} */
const bn_reset_request_email_label = en_reset_request_email_label;

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Reset_Request_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const reset_request_email_label = /** @type {((inputs?: Reset_Request_Email_LabelInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Request_Email_LabelInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_reset_request_email_label(inputs)
	if (locale === "he") return he_reset_request_email_label(inputs)
	if (locale === "ur") return ur_reset_request_email_label(inputs)
	if (locale === "es") return es_reset_request_email_label(inputs)
	if (locale === "fr") return fr_reset_request_email_label(inputs)
	if (locale === "de") return de_reset_request_email_label(inputs)
	if (locale === "pt") return pt_reset_request_email_label(inputs)
	if (locale === "hi") return hi_reset_request_email_label(inputs)
	if (locale === "bn") return bn_reset_request_email_label(inputs)
	return /** @type {LocalizedString} */ ("Email")
});